import SuspensionDialog from "./SuspensionDialog";

export default SuspensionDialog;
